import React from "react";
import CustomIcon from "components/CustomIcon";
import { useDispatch } from "react-redux";
import { selectUserProfilePhoto, setIsAuthenticationOpen, setOAuthOpenedFromButton } from "lib/redux/uiSlice";
import { sanitizeResume } from "lib/utils/sanitizeResume";
import { useAppSelector } from "lib/redux/hooks";
import { changeProfileStatus, selectResume, setResume } from "lib/redux/resumeSlice";
import { createResume, updateResume } from "api/resumeApi";
import axios from "axios";
import { store } from "lib/redux/store";
import { saveStateToLocalStorage } from "lib/redux/local-storage";
import { setResumeCache } from "../../utils/localStorageHelper";

interface FixButtonsProps {
  isEditMode: boolean;
  toggleEditMode: () => void;
}

export const FixButtons: React.FC<FixButtonsProps> = ({
  isEditMode,
  toggleEditMode,
}) => {
  const dispatch = useDispatch();
  const resume = useAppSelector(selectResume)
  const userProfilePhoto = useAppSelector(selectUserProfilePhoto);
  const handleSaveResume = async () => {
      dispatch(setOAuthOpenedFromButton("save"));
      try {
        const access_token = localStorage.getItem("access-token");
        if (!access_token) {
          dispatch(setIsAuthenticationOpen(true));
          localStorage.setItem("auth-overlay", "false");
          return;
        }
        const sanitizedResume = sanitizeResume(resume);
        
        if (resume.id) {
          const updatedResume = await updateResume(
            sanitizedResume,
            resume.id,
            userProfilePhoto!
          );
          
          // Update Redux state
          dispatch(setResume(updatedResume));
          
          // Update resumeCache in localStorage
          setResumeCache({ resume: updatedResume });
          
          // CRITICAL: Update localStorage with the correct key used by useSetInitialStore
          // This ensures navigation to builder will load the fresh data
          const currentState = store.getState();
          saveStateToLocalStorage({
            ...currentState,
            resume: updatedResume,
          });
        } else {
          const createdResume = await createResume(
            sanitizedResume,
            userProfilePhoto!
          );
          
          // Update Redux state
          dispatch(setResume(createdResume));
          
          // Update resumeCache in localStorage
          setResumeCache({ resume: createdResume });
          
          // CRITICAL: Update localStorage with the correct key
          const currentState = store.getState();
          saveStateToLocalStorage({
            ...currentState,
            resume: createdResume,
          });
        }
        dispatch(changeProfileStatus("IGNORED"));
      } catch (error: any) {
        if (error.code === "TOKEN_EXPIRED") {
          dispatch(setIsAuthenticationOpen(true));
        }
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          const createdResume = await createResume(resume, userProfilePhoto!);
          dispatch(setResume(createdResume));
          
          // Update resumeCache in localStorage
          setResumeCache({ resume: createdResume });
          
          // Update localStorage after error recovery
          const currentState = store.getState();
          saveStateToLocalStorage({
            ...currentState,
            resume: createdResume,
          });
        }
      }
    };
  return (
    <div className="flex w-full my-1 items-center justify-center gap-2 sm:gap-3 md:gap-5 lg:gap-10">
      {/* <button className="rounded-full flex items-center gap-1 sm:gap-2 lg:gap-3 justify-center shadow-md bg-gradient-to-r to-[#0085FF] from-[#88C4FC] px-3 sm:px-5 md:px-6 lg:px-[36px] py-1 sm:py-2 lg:py-[8px] text-xs sm:text-sm md:text-base lg:text-lg font-medium text-white">
        <span className="hidden xs:inline">Fix with</span> Ai
        <CustomIcon iconName="ai" className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5" />
      </button> */}
      <button
        onClick={() => {
          if( isEditMode ){
            handleSaveResume()
          }
          toggleEditMode()
        }}
        className="rounded-full flex items-center gap-1 sm:gap-2 lg:gap-3 shadow-md bg-[linear-gradient(264.98deg,_#0085FF_-0.45%,_#88C4FC_82.08%)] px-4 sm:px-5 md:px-6 lg:px-[36px] py-1 sm:py-2 lg:py-[8px] text-xs sm:text-sm md:text-base lg:text-lg font-medium text-white"
      >
        {isEditMode ? "Save" : <span className="whitespace-nowrap">{typeof window !== 'undefined' && window.innerWidth < 350 ? "Fix" : "Fix"}</span>}
        <CustomIcon iconName="import" className="w-3 h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5 text-white " />
      </button>
    </div>
  );
};